import React from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Collapse, NavItem, NavLink } from "shards-react";
import authStore, { types as authTypes, actions as authActions } from "../../../../_stores/auth.store";
import { MsalContext } from "@azure/msal-react";

export default class UserActions extends React.Component {
  static contextType = MsalContext;

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      user: {},
    };
    this.toggleUserActions = this.toggleUserActions.bind(this);
    this.userLogout = this.userLogout.bind(this);
    this.appStoreToState = this.appStoreToState.bind(this);
  }

  componentWillMount() {
    this.appStoreToState();
    this.authUnsubscribe = authStore.subscribe(this.appStoreToState);
  }

  appStoreToState() {
    const user = authStore.getState().auth_reducer.user.name
      ? authStore.getState().auth_reducer.user
      : authStore.getState().sso_reducer.account;
    this.setState({ user });
  }

  componentWillUnmount() {
    this.authUnsubscribe();
  }

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  userLogout() {
    const { instance } = this.context;
    authStore.dispatch({ type: authTypes.INIT_AUTH_STATE });
    authStore.dispatch({ type: authTypes.INIT_SSO_STATE });
    authActions.removeAuthStorage();
    if (instance.getActiveAccount())
      instance.logoutRedirect({
        account: instance.getActiveAccount(),
      });
  }

  render() {
    const { visible, user } = this.state;

    return (
      <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
        <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
          {/* <img
            className="user-avatar rounded-circle mr-2"
            src={require("./../../../../images/avatars/1.jpg")}
            alt="User Avatar"
          />{" "} */}
          <span className="d-none d-md-inline-block">{user && user.name}</span>
        </DropdownToggle>
        <Collapse tag={DropdownMenu} right small open={visible}>
          {/* <DropdownItem tag={Link} to="user-profile">
            <i className="material-icons">&#xE7FD;</i> Profile
          </DropdownItem>
          <DropdownItem tag={Link} to="edit-user-profile">
            <i className="material-icons">&#xE8B8;</i> Edit Profile
          </DropdownItem>
          <DropdownItem tag={Link} to="file-manager-list">
            <i className="material-icons">&#xE2C7;</i> Files
          </DropdownItem>
          <DropdownItem tag={Link} to="transaction-history">
            <i className="material-icons">&#xE896;</i> Transactions
          </DropdownItem> */}
          <DropdownItem divider />
          <DropdownItem tag={"a"} to="javascript:void(0)" onClick={this.userLogout} className="text-danger">
            <i className="material-icons text-danger">&#xE879;</i> Logout
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}
